import { isNil } from 'lodash';

export const isExistingRecord = (record: { id?: string }) => !isNil(record.id) && record.id.length > 0;
